import { AfterViewInit, Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { ICardNav, IColumns, ICards } from 'bi-interfaces';
import { CreateDialog } from '../bi-dialog/createDialog.service';
import { CompositeFilterDescriptor, SortDescriptor, toODataString, process } from '@progress/kendo-data-query';
import { BiCardFilterComponent } from '../bi-card-filter/bi-card-filter.component';
import { BiCardSorterComponent } from '../bi-card-sorter/bi-card-sorter.component';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { LoadingMode } from '../bi-cards/bi-cards.component';
import { INavBtn } from 'bi-interfaces/lib/interfaces/inav-btn';

@Component({
  selector: 'bi-card-nav',
  templateUrl: './bi-card-nav.component.html',
  styleUrls: ['./bi-card-nav.component.scss']
})
export class BiCardNavComponent implements ICardNav, AfterViewInit {

  filter !: CompositeFilterDescriptor;
  sorter !: SortDescriptor;
  isSorterOpen!: boolean;
  FilterDialog = this._dialog() as CreateDialog;
  SorterDialog = this._dialog() as CreateDialog;
  @Input() isFilterActive: boolean = true;
  @Input() isSorterActive: boolean = true;
  @Input() isRefreshActive: boolean = true;
  @Input() isCustomFilter: boolean = false;
  @Input() isCustomSorter: boolean = false;
  @Input() PageTitle!: string;
  @Input() CardList!: ICards;
  @Input() Columns!: IColumns[];
  @Input() navButtons: INavBtn = {};
  @Input() CanInsert!: boolean;
  @Input() CanUpdate!: boolean;
  @Input() CanDelete!: boolean;
  @Input() CanViewAttachments!: boolean;
  @Input() CanAddAttachments!: boolean;
  @Input() CanDeleteAttachments!: boolean;
  @Output() ActionClicked = new EventEmitter<any>();
  @Input() DomID!: string;
  @Output() CustomFilter = new EventEmitter<any>();
  @Output() CustomSorter = new EventEmitter<any>();
  constructor(@Inject('CreateDialog') public _dialog: any,
    public translateService: TranslateService) {
      this.navButtons = {
        add: {
          disable: false,
          visibility: false
        },
        save: {
          disable: false,
          visibility: false
        },
        delete: {
          disable: false,
          visibility: false
        },
        cancel: {
          disable: false,
          visibility: false
        },
  
      }

  }

  ngAfterViewInit(): void {
    this.Columns = this.Columns?.filter(res => res.IsFilterable);
    this.Columns = this.Columns.map(element => {
      if (element.controlType === "boolean") {
        return {
          ...element,
          DataType: "boolean",
          DisplayName: this.translateService.instant(element.DisplayName),
          CustomFilter: this.isCustomFilter
        };
      }
      else if (element.controlType === "lookup") {
        return {
          ...element,
          DataType: "string",
          DisplayName: this.translateService.instant(element.DisplayName),
          CustomFilter: this.isCustomFilter
        };
      }
      else if (element.DataType === "numeric") {
        return {
          ...element,
          DataType: "number",
          DisplayName: this.translateService.instant(element.DisplayName),
          CustomFilter: this.isCustomFilter
        };
      }
      else if (element.DataType === "text") {
        return {
          ...element,
          DataType: "string",
          DisplayName: this.translateService.instant(element.DisplayName),
          CustomFilter: this.isCustomFilter
        };
      }
      else {
        return {
          ...element,
          DisplayName: this.translateService.instant(element.DisplayName),
          CustomFilter: this.isCustomFilter
        };
      }
    });
  }

  refresh() {
    this.CardList.DataService.state.skip = 0;
    this.CardList.read();
  }

  //#region Filter

  FilterSubscribtion !: Subscription;
  OnOpenFilter() {

    this.FilterDialog.ShowDialog(BiCardFilterComponent,
      {
        value: this.filter,
        Columns: this.Columns,
        Dialog: this.FilterDialog
      },
      this.translateService.instant('Filter'), this.translateService.instant('OK'),
      this.translateService.instant('Cancel'), true, true);

    if (this.FilterSubscribtion)
      this.FilterSubscribtion.unsubscribe();
    this.FilterSubscribtion = this.FilterDialog.DialogReturnSubject.subscribe(res => {
      if (res) {
        this.filter = res.state?.filter;
        if (!this.isCustomFilter) {
          this.OnFilter(res.state)
        }
        else {
          this.CustomFilter.emit(res.state);
        }
      }
    })

  }

  OnFilter(state: any) {
    if(this.CardList.LoadingMode === LoadingMode.Eager){
      this.CardList.view = process(this.CardList.data,state).data;
    }
    else{
      this.CardList.filters = toODataString(state);
    }
  }

  //#endregion

  //#region Sorter

  SorterSubscribtion !: Subscription;
  OnOpenSorter() {
    if (!this.isCustomSorter) {
      this.SorterDialog.ShowDialog(BiCardSorterComponent,
        {
          value: this.sorter,
          Columns: this.Columns,
          Dialog: this.SorterDialog
        },
        this.translateService.instant('Sort'), this.translateService.instant('OK'),
        this.translateService.instant('Cancel'), true, true);

      if (this.SorterSubscribtion)
        this.SorterSubscribtion.unsubscribe();
      this.SorterSubscribtion = this.SorterDialog.DialogReturnSubject.subscribe(res => {
        if (res)
          this.OnSort(res.state)
      })
    }
    else {
      this.CustomSorter.emit();
    }
  }

  OnSort(state: any) {
    this.sorter = state?.sort;
    if(this.CardList.LoadingMode === LoadingMode.Eager){
      this.CardList.view = process(this.CardList.data,state).data;
    }
    else{
      this.CardList.sorter = toODataString(state);
    }
  }

  //#endregion

  AddRow(): void {
    this.ActionClicked.emit({ action: 'add' });
    this.CardList.AddRow();
  };
  Save() {
    this.ActionClicked.emit({ action: 'save' });
    this.CardList.Save();
  }
  DeleteCard() {
    this.ActionClicked.emit({ action: 'delete' });
    this.CardList.DeleteRow();
  }
  Cancel() {
    this.ActionClicked.emit({ action: 'cancel' });
    this.CardList.Cancel();
  }

}
